import { ClassroomLocation, Info } from '@berlitz/icons'
import CalendarFavorite from '@berlitz/streamline-icons/lib/regular/01-Interface-Essential/21-Date-Calendar/CalendarFavorite'
import Instructor from '@berlitz/streamline-icons/lib/regular/36-School-Learning/01-School/SchoolTeacher'
import Building from '@berlitz/streamline-icons/lib/regular/49-Building-Construction/03-Buildings/Building1'
import ConversationChatText from '@berlitz/streamline-icons/lib/regular/21-Messages-Chat-Smileys/03-Conversation/ConversationChatText'
import BookOpenText from '@berlitz/streamline-icons/lib/regular/11-Content/02-Books/BookOpenText'
import Tooltip from '@components/Tooltip'
import React from 'react'
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl'
import { Col } from 'react-styled-flexboxgrid'
import { IconItemWrapper, InfoCol, TooltipRow } from './style'

interface IClassLocation extends InjectedIntlProps {
  isOnline?: boolean
  isMeeting?: boolean
  room?: string
  lc?: string
  lcId?: string
  instructor?: string
  instructorId?: string
  ProgramName?: string
  ForCounselling?: boolean
  ProgramType?: string
  isStudent?: boolean
  isF2fStar?: boolean
  isSelfStudy?: boolean
}

const ClassDetails: React.FC<IClassLocation> = ({
  intl,
  isOnline,
  room,
  lc,
  lcId,
  isMeeting,
  ProgramName,
  instructor,
  instructorId,
  ForCounselling,
  ProgramType,
  isStudent,
  isF2fStar,
  isSelfStudy
}) => {
  const tooltipMsg = intl.formatMessage({
    id: 'Your room will be confirmed after 5pm the day before your class.',
  })
  const roomName =
    room ||
    intl.formatMessage({
      id: 'Room to be confirmed',
    })
  const location = isOnline ? <FormattedMessage id="Online" /> : roomName
  const LessonType = ['Charter Online', 'Group Online Level Based']
  const shouldShowCounseling =
    ForCounselling &&
    (!isStudent || // If not a student, always show (don't check LessonType)
      !LessonType.includes(ProgramType || '')) // If student, only show if ProgramType not in LessonType

  return (
    <InfoCol md={8}>
      {isMeeting && (
        <IconItemWrapper>
          <CalendarFavorite /> <a>{ProgramName}</a>
        </IconItemWrapper>
      )}
      {isSelfStudy ? (<IconItemWrapper>
        <BookOpenText color='#8B8C94' /> <FormattedMessage id="Self study" defaultMessage="Self study" />
      </IconItemWrapper>) : instructor && instructorId && (
        <IconItemWrapper>
          <Instructor /> {isF2fStar ? instructor : <a href={`/instructor/?id=${instructorId}`}>{instructor}</a>}
        </IconItemWrapper>
      )}
      {lc && lcId && !isOnline && (
        <IconItemWrapper>
          <Building />
          {isF2fStar ? lc : <a href={`/learning-center/?id=${lcId}`}>{lc}</a>}
        </IconItemWrapper>
      )}
      <IconItemWrapper>
        {isOnline ? <Building /> : <ClassroomLocation />}
        {location}

        {!room && !isOnline && (
          <TooltipRow>
            <Col xs={false} sm={0}>
              <Tooltip message={tooltipMsg} placement="topLeft">
                <Info size="xs" />
              </Tooltip>
            </Col>
            <Col xs={0} sm={false}>
              <Tooltip message={tooltipMsg} placement="bottomRight">
                <Info size="xs" />
              </Tooltip>
            </Col>
          </TooltipRow>
        )}
      </IconItemWrapper>
      {shouldShowCounseling && (
        <IconItemWrapper>
          <ConversationChatText />
          {intl.formatMessage({ id: 'Counseling' })}
        </IconItemWrapper>
      )}
    </InfoCol>
  )
}

export default injectIntl(ClassDetails)
